<template>
  <div class="page flex-col justify-between">
    <div class="box_1 flex-col">
      <div class="group_1 flex-row">
        <img
          class="label_1"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNGcdff11e08207d5782e9198c64898272b.png')"
        />
        <img
          class="image_1"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG4724cd4fdb63b84c20b5fdc9c9238410.png')"
        />
        <span class="text_1">首页</span>
        <span class="text_2">解决方案</span>
        <span class="text_3">康复助手</span>
        <span class="text_4">产品介绍</span>
        <img
          class="thumbnail_1"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNGa14a240930f6ce8957ded5645604cdd7.png')"
        />
        <span class="text_5">功能及报价</span>
        <span class="text_6">关于我们</span>
        <div class="box_2 flex-row">
          <span class="text_7">登录</span>
          <div class="section_1 flex-col"></div>
        </div>
      </div>
      <span class="text_8">通用医疗运动处方工作站</span>
      <div class="group_2 flex-row">
        <div class="group_3 flex-col">
          <span class="text_9">general&nbsp;medical&nbsp;exercise&nbsp;prescription&nbsp;station&nbsp;[GMEPS]</span>
          <span class="text_10">医生总运动处方开具和数据管理平台</span>
          <span class="paragraph_1">
            核心技术专利
            <br />
            以动健康运动处方数据库
          </span>
          <span class="paragraph_2">
            运动处方的基础设施
            <br />
            一个存储运动处方的大型图书馆
            <br />
            数据库
          </span>
          <div class="box_3 flex-col justify-center align-center">
            <div class="text-wrapper_1 flex-col"><span class="text_11">物联网设备和新引擎</span></div>
          </div>
          <div class="box_4 flex-col justify-center align-center">
            <div class="text-wrapper_2 flex-col"><span class="text_12">真正定制化的运动处方</span></div>
          </div>
          <div class="box_5 flex-col justify-center align-center">
            <div class="text-wrapper_3 flex-col"><span class="text_13">稳定服务质量</span></div>
          </div>
        </div>
        <div class="group_4 flex-col">
          <div class="section_2 flex-col justify-center align-center">
            <div class="text-wrapper_4 flex-col"><span class="text_14">居家运动处方发送与打印</span></div>
          </div>
        </div>
      </div>
      <div class="group_5 flex-col justify-center align-center">
        <div class="text-wrapper_5 flex-col"><span class="text_15">标准化运动处方开局流程</span></div>
      </div>
      <div class="text-wrapper_6 flex-col">
        <span class="text_16">运动处方系统及本地化工作站</span>
        <span class="text_17">功复道&nbsp;&nbsp;&nbsp;PF-E26</span>
        <span class="text_18">健康体适能测评仪</span>
        <span class="text_19">人体成分分析仪</span>
        <span class="text_20">全身有氧训练机（前摆臂）IC7006</span>
        <span class="text_21">全身线性有氧健身机&nbsp;IC7007</span>
        <span class="text_22">全身脑部肢体协调训练机&nbsp;IC7009</span>
      </div>
      <div class="group_6 flex-col"></div>
    </div>
    <div class="box_6 flex-col">
      <div class="image-wrapper_1 flex-row justify-between">
        <img
          class="label_2"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNGcdff11e08207d5782e9198c64898272b.png')"
        />
        <img
          class="image_2"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG33f935e7aff511ef96bc22348410d09b.png')"
        />
      </div>
      <div class="box_7 flex-row">
        <div class="group_7 flex-col justify-between">
          <div class="text-wrapper_7 flex-row justify-between">
            <span class="text_23">联系方式：13220190868</span>
            <span class="text_24">Email：info&#64;ktangtang.com</span>
          </div>
          <span class="text_25">官网地址：https://ktangtang.com</span>
          <span class="text_26">公司地址：&nbsp;北京市顺义区中关村科技园区顺义园汇海中路7号院221-03室</span>
        </div>
        <div class="text-wrapper_8 flex-col justify-between">
          <span class="text_27">公众号：以动健康</span>
          <span class="text_28">官方微博：&#64;以动健康</span>
          <span class="text_29">京ICP备19026627号</span>
        </div>
        <div class="image-text_1 flex-col justify-between">
          <img
            class="image_3"
            referrerpolicy="no-referrer"
            v-lazy="require('./assets/img/FigmaDDSSlicePNGb44291ba8e983b81bea2ee1b1a2e5ed9.png')"
          />
          <span class="text-group_1">公众号二维码</span>
        </div>
      </div>
    </div>
    <div class="box_8 flex-col">
      <div class="section_3 flex-row">
        <div class="group_8 flex-col"></div>
        <div class="group_9 flex-col"></div>
        <div class="group_10 flex-col"></div>
        <div class="group_11 flex-col"></div>
        <img
          class="thumbnail_2"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG08ee2d5e57b66786139b8f5db3c124df.png')"
        />
        <img
          class="thumbnail_3"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNGd06c6ef29faf1a57d5ba92308f9d59a9.png')"
        />
        <img
          class="thumbnail_4"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG381ad4aa090a4e1c3ba6b827ad82b8ab.png')"
        />
        <span class="text_30">产品逻辑</span>
      </div>
      <div class="section_4 flex-col">
        <span class="text_31">系统及工作站</span>
        <img
          class="image_4"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG0976489c30c29fd58718c9ba77bbc863.png')"
        />
      </div>
      <img
        class="image_5"
        referrerpolicy="no-referrer"
        v-lazy="require('./assets/img/FigmaDDSSlicePNG66c4cfa95a84833afae713d8f6237731.png')"
      />
      <div class="section_5 flex-row">
        <span class="paragraph_3">
          报
          <br />
          告
          <br />
          输
          <br />
          出
        </span>
        <div class="box_9 flex-col"></div>
        <span class="paragraph_4">
          实
          <br />
          时
          <br />
          共
          <br />
          享
        </span>
        <span class="paragraph_5">
          命
          <br />
          令
          <br />
          下
          <br />
          达
        </span>
        <div class="box_10 flex-col"></div>
        <span class="paragraph_6">
          数
          <br />
          据
          <br />
          上
          <br />
          传
        </span>
        <span class="paragraph_7">
          实
          <br />
          时
          <br />
          连
          <br />
          接
        </span>
        <div class="box_11 flex-col"></div>
        <span class="paragraph_8">
          数
          <br />
          据
          <br />
          上
          <br />
          传
        </span>
        <span class="paragraph_9">
          处
          <br />
          方
          <br />
          下
          <br />
          达
        </span>
        <div class="box_12 flex-col"></div>
        <span class="paragraph_10">
          数
          <br />
          据
          <br />
          上
          <br />
          传
        </span>
      </div>
      <div class="section_6 flex-row">
        <div class="text-wrapper_9 flex-col"><span class="text_32">患者端小程序</span></div>
        <div class="section_7 flex-col"></div>
        <div class="text-wrapper_10 flex-col"><span class="text_33">运动中的安全设备</span></div>
        <div class="text-wrapper_11 flex-col"><span class="text_34">运动设备</span></div>
      </div>
      <div class="image-wrapper_2 flex-row">
        <img
          class="image_6"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNGd5dc5b89a819d383ccd7e9d0d2d80038.png')"
        />
        <img
          class="image_7"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNGdc5e37ffc31f35a95f7afd69214f85a2.png')"
        />
        <img
          class="image_8"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNGe5c540207578aec477625f4a23c9db01.png')"
        />
        <img
          class="image_9"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG6601aaad353b673a6472c6e13fc87496.png')"
        />
      </div>
      <div class="text-wrapper_12 flex-row">
        <span class="paragraph_11">
          患者手机端康复小程序
          <br />
          实时上传患者数据及查看运动处方
        </span>
        <span class="text_35">体适能评估和关节角度评估设备</span>
        <span class="text_36">心率监控手环等</span>
        <span class="text_37">功率车和四肢联动设备等</span>
      </div>
      <div class="section_8 flex-row justify-between">
        <div class="section_9 flex-col">
          <div class="image-text_2 flex-row justify-between">
            <img
              class="label_3"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG93ad85b11ef321ea36641f0419446a97.png')"
            />
            <div class="block_1 flex-col">
              <div class="block_2 flex-col"></div>
              <span class="text-group_2">以动健康产品治疗成果十分显著</span>
            </div>
          </div>
          <div class="group_12 flex-col"></div>
          <div class="group_13 flex-col"></div>
          <div class="text-wrapper_13">
            <span class="text_38">疾病康复效果明显</span>
            <span class="text_39">：</span>
            <span class="text_40">
              2018年，与北京大学第一医院合作的“运动处方控糖项目”临床研究显示，我司运动处方使病患“三高控制率”提升近一倍；血糖、血脂、血压的单项达标率及三项混合达标率都显著增加
            </span>
          </div>
          <div class="text-wrapper_14">
            <span class="text_41">运动意愿提升显著</span>
            <span class="text_42">：</span>
            <span class="text_43">2019年，</span>
            <span class="text_44">
              与北京大学第一医院内分泌科合作“运动处方远程干预项目”临床研究显示，患者运动自我效能（运动意愿）显著提高，糖化血红蛋白控制显著变好
            </span>
          </div>
        </div>
        <div class="section_10 flex-col justify-between">
          <img
            class="image_10"
            referrerpolicy="no-referrer"
            v-lazy="require('./assets/img/FigmaDDSSlicePNGfa53c4b46878252aa9175978d7823d86.png')"
          />
          <div class="image-wrapper_3 flex-row justify-between">
            <img
              class="image_11"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG625fc3f44069905c6e44a277b887831f.png')"
            />
            <img
              class="image_12"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG39fb3a8bcf7a3a83ebb7a672d39637b5.png')"
            />
          </div>
        </div>
      </div>
      <img
        class="image_13"
        referrerpolicy="no-referrer"
        v-lazy="require('./assets/img/FigmaDDSSlicePNGa1d709c619b00914290a602802ddc97f.png')"
      />
      <div class="section_11 flex-row">
        <img
          class="image_14"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNGef90c59acbe218cca63ff99b7ad97664.png')"
        />
        <div class="section_12 flex-col">
          <div class="image-wrapper_4 flex-col">
            <img
              class="image_15"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG9e6b1607d84622bc32c89ab002e7a44e.png')"
            />
          </div>
        </div>
        <img
          class="image_16"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNGa1c63be730897713032983e7287004e9.png')"
        />
        <img
          class="image_17"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNGdc8febba2c72d746d86dc36969c9f626.png')"
        />
        <img
          class="image_18"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG9f92dd01ef288e7476c5f393580ecbc7.png')"
        />
        <img
          class="image_19"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG00226ea9b36f96d8b5f76e19e50a1867.png')"
        />
        <img
          class="image_20"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG4562632520a33289a2a20a5b365ef6b5.png')"
        />
        <img
          class="image_21"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNGf95579cb1824609824cd748de7d8361f.png')"
        />
      </div>
      <div class="section_13 flex-row">
        <div class="section_14 flex-col"></div>
        <div class="section_15 flex-col"></div>
        <div class="section_16 flex-col"></div>
        <div class="section_17 flex-col"></div>
        <div class="section_18 flex-col"></div>
        <div class="section_19 flex-col"></div>
        <div class="section_20 flex-col"></div>
        <div class="section_21 flex-col"></div>
      </div>
      <div class="section_22 flex-row">
        <div class="group_14 flex-col">
          <div class="image-wrapper_5 flex-col">
            <img
              class="image_22"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG01a4fdf7030203f7af10314f19e6cfd3.png')"
            />
          </div>
        </div>
        <div class="group_15 flex-col"></div>
        <div class="group_16 flex-col"></div>
        <div class="group_17 flex-col"></div>
        <div class="group_18 flex-row">
          <div class="group_19 flex-col"></div>
          <span class="text_45">数据中心及系统</span>
        </div>
        <img
          class="thumbnail_5"
          referrerpolicy="no-referrer"
          v-lazy="require('./assets/img/FigmaDDSSlicePNG08ee2d5e57b66786139b8f5db3c124df.png')"
        />
        <div class="group_20 flex-col">
          <div class="image-wrapper_6 flex-row justify-between">
            <img
              class="thumbnail_6"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNGd06c6ef29faf1a57d5ba92308f9d59a9.png')"
            />
            <img
              class="thumbnail_7"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG381ad4aa090a4e1c3ba6b827ad82b8ab.png')"
            />
          </div>
          <div class="group_21 flex-row justify-between">
            <div class="box_13 flex-row">
              <div class="text-group_3 flex-col justify-between">
                <span class="text_46">高效</span>
                <span class="text_47">01</span>
              </div>
            </div>
            <div class="text-wrapper_15 flex-col">
              <span class="text_48">90%</span>
              <span class="text_49">比传统开具运动处方节省95%的时间</span>
            </div>
            <img
              class="label_4"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG6d71c1808137118b0f5bcad33d328db0.png')"
            />
          </div>
          <div class="group_22 flex-row justify-between">
            <div class="text-wrapper_16 flex-col">
              <span class="text_50">2万+</span>
              <span class="text_51">运动模块历经超过2万次调教和标记</span>
            </div>
            <div class="box_14 flex-row">
              <div class="text-group_4 flex-col justify-between">
                <span class="text_52">科学</span>
                <span class="text_53">02</span>
              </div>
            </div>
            <img
              class="label_5"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG7da252a788542e7d11e602376960b89e.png')"
            />
          </div>
          <div class="group_23 flex-row justify-between">
            <div class="section_23 flex-row">
              <div class="text-group_5 flex-col justify-between">
                <span class="text_54">权威</span>
                <span class="text_55">03</span>
              </div>
            </div>
            <div class="text-wrapper_17 flex-col">
              <span class="text_56">20+</span>
              <span class="paragraph_12">
                基于20余权威医疗指南，与国内一线三甲
                <br />
                医院共同发，并开展临床研究验证有效性
              </span>
            </div>
            <img
              class="label_6"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG6d71c1808137118b0f5bcad33d328db0.png')"
            />
          </div>
          <div class="group_24 flex-row justify-between">
            <div class="text-wrapper_18 flex-col">
              <span class="text_57">10万+</span>
              <span class="paragraph_13">
                数据库里面的动作可以组成需要的
                <br />
                个性化的运动处方
              </span>
            </div>
            <div class="group_25 flex-row">
              <div class="text-group_6 flex-col justify-between">
                <span class="text_58">丰富</span>
                <span class="text_59">04</span>
              </div>
            </div>
            <img
              class="label_7"
              referrerpolicy="no-referrer"
              v-lazy="require('./assets/img/FigmaDDSSlicePNG7da252a788542e7d11e602376960b89e.png')"
            />
          </div>
        </div>
      </div>
      <div class="text-wrapper_19 flex-col"><span class="text_60">数据中心及系统</span></div>
      <div class="section_24 flex-col"></div>
      <div class="section_25 flex-col"></div>
      <div class="section_26 flex-col"></div>
      <div class="section_27 flex-col"></div>
      <span class="text_61">评估设备</span>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      constants: {}
    };
  },
  methods: {}
};
</script>
<style scoped lang="css" src="./assets/index.css" />